<div class="iic-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell iic-shell">
    <div class="custom-container">
      <div class="content-shell iic-content-shell">
        <!-- HERO -->
        <header class="page-hero">
          <span class="page-kicker">Innovation &amp; Entrepreneurship</span>
          <h1>Institute Innovation Council (IIC)</h1>
          <p>
            An initiative aligned with the Ministry of Education’s Innovation Cell
            to nurture innovation, entrepreneurship, start-up culture, idea
            development, and institutional excellence among students and faculty.
          </p>
        </header>

        <!-- ABOUT IIC -->
        <section
          class="info-card"
          [class.dark-experience-area]="themeService.isDark()"
        >
          <div class="info-copy">
            <p>
              In the year 2018, the Institute Innovation Council (IIC) was introduced
              as an initiative of the Ministry of Education’s Innovation Cell (MIC),
              Government of India, to foster a culture of innovation and
              entrepreneurship in Higher Educational Institutions across the country.
            </p>
            <p>
              The primary objective of IIC is to encourage, inspire, and nurture
              young students by exposing them to innovative ideas, emerging processes,
              entrepreneurial opportunities, and technology-enabled problem solving
              during their formative years.
            </p>
          </div>
        </section>



        <!-- PROGRAMS -->
        <section class="panel-card">
          <div class="panel-head">
            <div>
              <span class="panel-tag">IIC Opportunities</span>
              <h2>Programs and Schemes for IIC Institutions</h2>
            </div>
          </div>

          <div class="scheme-grid">
            <div class="scheme-card" *ngFor="let item of programs; trackBy: trackByTitle">
              <div class="scheme-icon">
                <i [class]="item.icon"></i>
              </div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </section>

        <!-- MIC + FUNCTIONS -->
        <section class="panel-card">
          <div class="panel-head">
            <div>
              <span class="panel-tag">Innovation Ecosystem</span>
              <h2>MHRD’s Innovation Cell &amp; Functions of IIC</h2>
            </div>

            <a
              class="pdf-link"
              href="assets/img/pdf/EstablismentCertificate.pdf"
              target="_blank"
              rel="noopener"
            >
              Open PDF
            </a>
          </div>

          <div class="row g-4 align-items-start">
            <div class="col-lg-7 col-md-12">
              <div class="info-copy dual-copy">
                <h3>MHRD’s Innovation Cell</h3>
                <p>
                  The Ministry of HRD established MHRD’s Innovation Cell with the
                  mandate to work closely with Higher Educational Institutions to
                  harness the creative energy of students, encourage new ideas,
                  promote innovation, and support the emergence of start-ups and
                  entrepreneurial ventures.
                </p>
                <p>
                  MIC aims to create a complete innovation ecosystem starting from
                  idea generation to pre-incubation, incubation, and the growth of
                  successful start-ups. It also supports institution-level ranking
                  and recognition frameworks for innovation excellence.
                </p>

                <h3>Functions of IIC</h3>
                <ul class="info-list">
                  <li>Provide students and faculty with opportunities to participate in innovation-related initiatives and competitions.</li>
                  <li>Enable recognition through prizes, certificates, and institutional achievements.</li>
                  <li>Facilitate interaction with business leaders, innovators, and academicians.</li>
                  <li>Support students in nurturing and prototyping new ideas.</li>
                  <li>Offer mentoring support from industry professionals and experts.</li>
                  <li>Promote experimentation with new technologies and entrepreneurial culture.</li>
                  <li>Encourage exposure visits to companies and innovation ecosystems.</li>
                </ul>
              </div>
            </div>

            <div class="col-lg-5 col-md-12">
              <div class="pdf-card">
                <a
                  href="assets/img/pdf/EstablismentCertificate.pdf"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    src="assets/img/EstablismentCertificate.jpg"
                    class="pdf-image"
                    alt="IIC Establishment Certificate"
                    loading="lazy"
                  />
                </a>
                <div class="pdf-caption">IIC Establishment Certificate</div>
              </div>
            </div>
          </div>
        </section>

        <!-- MEMBERS -->
        <section class="panel-card">
          <div class="panel-head">
            <div>
              <span class="panel-tag">Official Committee</span>
              <h2>IIC Members</h2>
            </div>

            <a
              class="pdf-link"
              href="assets/img/pdf/IIC_Appreciation_Letter_AY_2022_23.pdf"
              target="_blank"
              rel="noopener"
            >
              Open PDF
            </a>
          </div>

          <div class="row g-4 align-items-start">
            <div class="col-lg-4 col-md-12">
              <div class="pdf-card">
                <a
                  href="assets/img/pdf/IIC_Appreciation_Letter_AY_2022_23.pdf"
                  target="_blank"
                  rel="noopener"
                >
                  <img
                    src="assets/img/pdf/IIC_Appreciation_Letter_AY_2022_23.jpg"
                    class="pdf-image"
                    alt="IIC Appreciation Letter"
                    loading="lazy"
                  />
                </a>
                <div class="pdf-caption">IIC Appreciation Letter / PDF preview</div>
              </div>
            </div>

            <div class="col-lg-8 col-md-12">
              <div class="table-wrap">
                <table class="table committee-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name of Member</th>
                      <th>Designation</th>
                      <th>Key role / Position assigned in IIC</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let m of committeeMembers; trackBy: trackBySno">
                      <td>{{ m.sno }}</td>
                      <td>{{ m.memberName }}</td>
                      <td>{{ m.designation }}</td>
                      <td>{{ m.role }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</div>